// import FnrFetch from 'Utilities/FnrFetch';
const devAPI = {};
export default devAPI;
